module.exports = __webpack_public_path__ + "img/logo-3.62a50973.png";